import { useLocation, Link } from 'react-router-dom';
import { Phone, MessageCircle } from 'lucide-react';
import restored from '../data/restored-pages.cjs';
import { siteInfo } from '../data/mock';
import { useContactActions } from '../hooks/useContactActions';
import { Button } from '../components/ui/button';
import { ServiceHeader } from '../components/services/ServiceHeader';
import { ServiceFooter } from '../components/services/ServiceFooter';
import { RestoredPageContent } from '../components/services/RestoredPageContent';

export default function RestoredPage() {
  const { pathname } = useLocation();
  const page = restored.restoredPages[pathname.replace(/\/+$/, '')];
  const { handleWhatsAppClick } = useContactActions(`Bonjour Maître Diamma, je souhaite une consultation : ${page.label}`);
  return (
    <div className="site-theme service-page restored-page min-h-screen bg-black text-white">
      <ServiceHeader handleWhatsAppClick={handleWhatsAppClick} />
      <main className="restored-main">
        <nav data-testid="restored-breadcrumb" aria-label="Fil d’Ariane" className="restored-breadcrumb">
          <Link data-testid="restored-home-link" to="/">Accueil</Link>
          <span aria-hidden="true"> / </span>
          <span data-testid="restored-breadcrumb-current" aria-current="page">{page.label}</span>
        </nav>
        <h1 data-testid="restored-page-title">{page.heading}</h1>
        <p data-testid="restored-practitioner-name" className="restored-practitioner">Maître Diamma</p>
        <a data-testid="restored-phone-link" href={`tel:${siteInfo.phone}`} className="restored-phone">
          <Phone aria-hidden="true" size={20} />{siteInfo.phoneDisplay}
        </a>
        <p data-testid="restored-page-description">{page.description}</p>
        <Button data-testid="restored-whatsapp-button" onClick={handleWhatsAppClick} className="bg-green-600 text-white">
          <MessageCircle aria-hidden="true" className="mr-2 w-5 h-5" />WhatsApp
        </Button>
        <RestoredPageContent page={page} />
      </main>
      <ServiceFooter />
    </div>
  );
}